function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: "101.7%",
  height: "117.8%",
  x: "-.8%",
  y: "-8.9%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.56555591 0 0 0 0 0.56555591 0 0 0 0 0.56555591 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#5933B4",
  fillRule: "nonzero",
  stroke: "#5933B4",
  strokeWidth: 0.5,
  d: "M951.59 38c-18.179 0-33.377 13.167-36.474 30.477-16.3 1.45-29.116 14.986-29.116 31.63 0 17.61 14.31 31.893 31.955 31.893h73.76v-5.755l-73.76-.96c-14.035 0-25.228-11.17-25.228-25.178 0-14.007 11.193-25.178 25.228-25.178a3.362 3.362 0 0 0 3.363-3.043c1.527-15.243 14.548-27.172 30.273-27.172 8.56 0 15.562 3.307 21.128 9.023a3.369 3.369 0 0 0 3.626.786c2.43-.92 5.89-1.416 8.882-1.416 12.083 0 22.134 8.914 23.546 20.51a3.359 3.359 0 0 0 2.207 2.78c9.611 3.522 16.293 12.752 16.293 23.71 0 14.007-11.193 25.179-25.228 25.179l-10.33.96V132h10.33c17.645 0 31.955-14.282 31.955-31.893 0-12.955-7.693-24.024-18.868-29.008-2.588-14.11-15.095-24.706-29.905-24.706-3.047 0-6.249.502-9.25 1.364-6.479-5.991-14.77-9.757-24.386-9.757z",
  filter: "url(#a)",
  opacity: 0.1,
  transform: "translate(-882 -34)"
});

const SvgIcBannerCvo = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 106,
    viewBox: "0 0 160 106",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcBannerCvo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-banner-cvo.53b3a159.svg";
export { ForwardRef as ReactComponent };